// @ts-nocheck

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { routeHasChanged } from './actions/router';
import useRouter from './hooks/useRouter';

const RouterListener = ({ children }) => {
  const { location } = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(routeHasChanged({ pathname: location.pathname, hash: location.hash }));
  }, [dispatch, location]);

  return children;
};

export default RouterListener;
